import { Howl } from "howler";
import { SliderManager } from "./SliderOperator";

const effects = [];

export const SoundEffectManager = {
  handleSoundEffect(url) {
    try {
      const effectSound = new Howl({
        src: [url],
        volume: SliderManager.volumeEffects * SliderManager.volumeMaster,
        html5: true
      });

      effectSound.play();
      effects.push(effectSound);

      effectSound.once("end", () => {
        const index = effects.indexOf(effectSound);
        if (index > -1) effects.splice(index, 1);
      });
    } catch (e) {
      console.error(e);
    }
  },

  updateEffectsVolume() {
    effects.forEach(howl =>
      howl.volume(SliderManager.volumeEffects * SliderManager.volumeMaster)
    );
  }
};
